/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

import { FieldProps } from 'formik'

import MuiRadioGroup, { RadioGroupProps as MuiRadioGroupProps } from '@material-ui/core/RadioGroup'

export interface RadioGroupProps extends FieldProps, Omit<MuiRadioGroupProps, 'name' | 'value'> {}

export default function RadioGroup({ field, ...props }: RadioGroupProps) {
  const data = {
    ...field,
    ...props,
    'data-hook': field.name,
  } as MuiRadioGroupProps
  return <MuiRadioGroup {...data} />
}

RadioGroup.displayName = 'FormikMaterialUIRadioGroup'
